import { createFileRoute } from "@tanstack/react-router";
import { findCity, type Country } from "@/lib/gold-data";
import { GoldCityAliasPage } from "@/components/GoldCityAliasPage";
import { canonicalCityPath, type GoldCityAlias } from "@/lib/alias-routes";

export const Route = createFileRoute("/city/$country/$city/")({
  // Each city has exactly one canonical home: the short-form URL
  // (/pakistan/lahore). This longer /city/... path renders the same page for
  // anyone who lands on it, but points its canonical there so the two URLs
  // are not competing as separate documents.
  head: ({ params }) => {
    const canonical = `https://drhint.com${canonicalCityPath(params.country as Country, params.city)}`;
    return {
      meta: [
        { name: "robots", content: "noindex,follow" },
        { property: "og:url", content: canonical },
      ],
      links: [{ rel: "canonical", href: canonical }],
    };
  },
  component: CityIndexPage,
});

function CityIndexPage() {
  const { country, city: citySlug } = Route.useParams() as { country: Country; city: string };
  const city = findCity(country, citySlug)!;
  const alias: GoldCityAlias = {
    slug: `${country}-${citySlug}`,
    country,
    citySlug,
    cityName: city.name,
  };
  return <GoldCityAliasPage alias={alias} h1={`Gold Price in ${city.name} Today`} />;
}